import DynamicLevelPreview from "@/components/Elements/FieldPreview/DynamicLevelPreview";
import { useGetObservationRiskMatrix } from "@/entities/observation";

export const TableCellRiskMatrix = ({ observation, field }) => {
  const { isLoading, ...risk } = useGetObservationRiskMatrix(observation);

  return (
    <DynamicLevelPreview
      loading={isLoading}
      field={field}
      level={risk[field]}
    />
  );
};
